import { ObserversModule } from '@angular/cdk/observers';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { BaseModule } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { IconModule } from '@sb/library/icon';
import { BannerComponent } from './banner.component';

@NgModule({
    declarations: [
        BannerComponent
    ],
    imports: [
        BaseModule,
        CommonModule,
        IconModule,
        ButtonModule,
        MatExpansionModule,
        ObserversModule
    ],
    exports: [
        BannerComponent
    ]
})
export class BannerModule { }
